import React, { useState, useMemo } from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
  LabelList,
} from "recharts";

const WithinTatDeliveryChart = ({ withinTATDeliveryInprocess }) => {
  const [selectedProcess, setSelectedProcess] = useState("Delivered");

  // filter data dynamically based on selected process
  const filteredData = useMemo(() => {
    return withinTATDeliveryInprocess.filter(
      (item) => item.processName === selectedProcess
    ).map((d) => ({
      tatCategory: d.tatCategory,
      W_SLA: d.w_SLA,
      O_SLA: d.o_SLA,
      GrandTotal: d.grandTotal,
    }));
  }, [withinTATDeliveryInprocess, selectedProcess]);

  return (
    <div
      style={{
        background: "linear-gradient(to bottom, #555, #666)",
        borderRadius: "15px",
        padding: "20px",
        width: "100%",
        height: "400px",
        position: "relative",
      }}
    >
      {/* Dropdown at top-left */}
      <select
        value={selectedProcess}
        onChange={(e) => setSelectedProcess(e.target.value)}
        style={{
          position: "absolute",
          top: "5px",
          left: "6px",
          padding: "5px 10px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          fontWeight: "bold",
          background: "inherit",
          marginBottom: "10px"
        }}
      >
        <option style={{ background: "inherit" }} value="Delivered">Delivered</option>
        <option style={{ background: "inherit" }} value="InProcess">InProcess</option>
      </select>

      <h3
        style={{
          textAlign: "center",
          color: "white",
          marginBottom: "10px",
          fontWeight: "bold",
        }}
      >
      </h3>

      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart
          data={filteredData}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <CartesianGrid stroke="rgba(255,255,255,0.2)" vertical={false} />
          <XAxis dataKey="tatCategory" stroke="white" />
          <YAxis
            stroke="white"
            domain={[0, 100]}
            tickFormatter={(val) => `${val}%`}
          />
          <Tooltip formatter={(value) => `${value}%`} />
          <Legend
            wrapperStyle={{ color: "white" }}
            formatter={(value) => {
              if (value === "W_SLA") return "W SLA";
              if (value === "O_SLA") return "O SLA";
              return value;
            }}
          />

          <defs>
            <linearGradient id="orangeGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FF7C47" />
              <stop offset="100%" stopColor="#FFB088" />
            </linearGradient>
            <linearGradient id="greyGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#ddd" />
              <stop offset="100%" stopColor="#999" />
            </linearGradient>
          </defs>

          <Bar
            dataKey="W_SLA"
            fill="url(#orangeGrad)"
            barSize={40}
            radius={[5, 5, 0, 0]}
          >
            <LabelList
              dataKey="W_SLA"
              position="top"
              formatter={(val) => `${val}%`}
              fill="white"
            />
          </Bar>

          <Bar
            dataKey="O_SLA"
            fill="url(#greyGrad)"
            barSize={40}
            radius={[5, 5, 0, 0]}
          >
            <LabelList
              dataKey="O_SLA"
              position="top"
              formatter={(val) => `${val}%`}
              fill="white"
            />
          </Bar>
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WithinTatDeliveryChart;